import { RendererType } from '../data-models/field-definition';
import { IField } from '../data-models/field2.data-model';
import { ISelectMeta, PrimitiveType } from '../data-models/field3.data-model';
import { IFormatterDataModel } from '../data-models/formatter.data-model';
import { FormatterFn, StandardFormatterId } from '../util/formatter-service';

export interface IDisplayField<MetaType> {
  dataType?: PrimitiveType;
  description?: string;
  isCalculated?: boolean;
  key: string;
  label?: string;
  formatter?: string | StandardFormatterId | IFormatterDataModel<unknown>;
  renderer: RendererType;
  rendererMeta?: MetaType;
  timeSeries?: IField<unknown>['timeSeries'];
}

export function createDisplayField<MetaType>(
  overrides: Partial<IDisplayField<MetaType>>
): IDisplayField<MetaType> {
  return {
    dataType: 'string',
    description: '',
    isCalculated: false,
    key: `display-field-${Math.round(Math.random() * 1000)}`,
    renderer: RendererType.text,
    timeSeries: false,
    ...overrides,
  };
}

export function getSelectFormatter<T>(field: IDisplayField<T>): FormatterFn<string> {
  const values = (field.rendererMeta as ISelectMeta<string>)?.values ?? [];
  const valueToLabelMap = values.reduce(
    (res, selectItem) => {
      res[selectItem.value] = selectItem.displayName ?? selectItem.value;
      return res;
    },
    {} as Record<string, string>
  );

  return (value: string) => {
    if (value == null) {
      return '';
    }
    return valueToLabelMap[value] ?? String(value);
  };
}

export function getMultiSelectFormatter<T>(field: IDisplayField<T>): FormatterFn<string[]> {
  const baseFormatter = getSelectFormatter(field);

  return (values: string[]) => {
    if (values == null) {
      return '';
    }
    return values.map((value) => baseFormatter(value)).join(', ');
  };
}
